exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".actions[data-v-2f09e416]{position:absolute;right:10px;top:10px}.deactivated-endpoint[data-v-2f09e416]{opacity:.6}.selectedContact[data-v-2f09e416]{background:#e6e6fa !important}.clipboard[data-v-2f09e416]{display:inline-block;padding:0;border:none;background:none}.clipboard svg[data-v-2f09e416]{pointer-events:none;width:12px;height:12px}.bottom[data-v-2f09e416]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.risoltoColor[data-v-2f09e416]{color:#ed6b1c}", ""]);

// exports
